// @ts-strict-ignore
import Retailer from './Retailer'
import { Text } from '@components/rolex-ui/Text'
import { cn } from '@lib/cn'
import { MultipleItemResponse } from '@lib/kontent'
import { RolexStorePageV72024 } from '@lib/kontent/models/RolexStorePageV72024'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

type Props = MultipleItemResponse<RolexStorePageV72024>

type CountryList = {
  [key: string]: RolexStorePageV72024[]
}

const splitByCountry = (items: MultipleItemResponse<RolexStorePageV72024>): CountryList => {
  let countries = {}
  for (const retailer of items.items) {
    const countryName = retailer.elements.country.value[0].codename
    if (countries[countryName]) {
      countries[countryName] = [...countries[countryName], retailer.elements]
    } else {
      countries[countryName] = [retailer.elements]
    }
  }
  return countries
}

const RetailerList: FC<Props> = (props) => {
  const { t } = useTranslation('rolex')
  const countryList = splitByCountry(props)
  return (
    <div>
      {Object.keys(countryList).map((country, index) => (
        <div key={index}>
          <Text variant="body24" className="mb-5">
            {t(`contact.${country}`)}
          </Text>

          <div className={cn('mb-10 grid grid-cols-1 gap-5 lg:grid-cols-3')}>
            {countryList[country].map((retailer, key) => (
              <Retailer key={key} retailer={retailer} />
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}

export default RetailerList
